import { useState } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { useDebug } from '../components/Debug';
import { useSubscribeQuery } from './useSubscribeQuery';

export const useQueryCache = (queryKey: any, filters: any = {}) => {
  const queryClient = useQueryClient();
  const { empty, skeleton, error, fetching } = useDebug();

  const [data, setData] = useState(() => {
    const prevState = queryClient.getQueryState(queryKey, {
      exact: false,
      ...filters,
    });
    return { ...prevState, isFetching: prevState?.fetchStatus === 'fetching' };
  });

  useSubscribeQuery({ queryKey, ...filters }, state => {
    setData(state);
  });

  if (skeleton && data) {
    return { ...data, isLoading: true, isSuccess: false };
  }

  if (fetching && data) {
    return { ...data, isFetching: true, isRefetching: true };
  }

  if (empty && data) {
    return { ...data, data: null };
  }

  if (error && data) {
    return { ...data, error: 'Mock error text', isError: true };
  }

  return data;
};
